export function createInternationalPhoneNumber(dialCode: string | null, phoneNumber: string | null): string {
    if (!!dialCode && !!phoneNumber) {
        console.error();
        return '+' + dialCode + phoneNumber;
    }
    else {
        return '';
    }
}

export function isValidE164PhoneNumber(internationalPhoneNumber: string | null | undefined): boolean {
    if (!internationalPhoneNumber) return false;
    const phoneNumber = internationalPhoneNumber.trim();
    const e164Regex = /^\+?[1-9]\d{1,14}$/;
    const isValidPhoneNumber = e164Regex.test(phoneNumber);
    return isValidPhoneNumber;
}

export function maskPhoneNumber(phoneNumber: string): string {
    const regex = /\d(?!\d{0,3}$)/gm;
    const maskedPhone = phoneNumber.replace(regex, '*');
    return maskedPhone;
}